module.exports = __webpack_public_path__ + "static/2-46060cf59869475a8ca16b99ad7f6b71.png";